import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import { Footer, Label, LabelText } from '../../../../../components/EnrollForm/EnrollFormStyles';
import Spinner from '../../../../../../CommonComponents/Spinner';
import FormikInput from '../../../../../../CommonComponents/FormikInput';
import FormikError from '../../../../../../CommonComponents/FormikError';
import { PrimaryButton, SecondaryButton } from '../../../../../../CommonComponents/Button';
import FormikSelect from '../../../../../../CommonComponents/FormikSelect';
import { Title } from '../../../ReportStyles';
import { addBankAccount } from '../../../../../ExperianActions';
import { BANK_ACCOUNT_TYPES } from '../DarkWebModalConstants';
import ExperianContext from '../../../../../ExperianContext';

const BankAccountForm = ({ onCancel, onRequestClose }) => {
  const getAccountNumberLabel = value => {
    switch (value) {
      case BANK_ACCOUNT_TYPES[0].value:
        return 'Account Number';
      case BANK_ACCOUNT_TYPES[1].value:
        return 'Credit Card Number';
      case BANK_ACCOUNT_TYPES[2].value:
        return 'Debit Card Number';
      default:
        return 'Account Number';
    }
  };

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        accountType: BANK_ACCOUNT_TYPES[0].value,
        accountNumber: '',
        bankRouting: '',
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(addBankAccount(clientId, subscriberId, values));
          onRequestClose();
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ values, errors, touched, isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Monitor Bank Account</Title>
          <Label>
            <LabelText>Account Type</LabelText>
            <Field
              type="text"
              name="accountType"
              component={FormikSelect}
              options={BANK_ACCOUNT_TYPES}
              size="small"
            />
            {errors.accountType && touched.accountType && <FormikError name="accountType" />}
          </Label>
          <Label>
            <LabelText>{getAccountNumberLabel(values.accountType)}</LabelText>
            <Field type="text" name="accountNumber" component={FormikInput} size="small" />
            {errors.accountNumber && touched.accountNumber && <FormikError name="accountNumber" />}
          </Label>
          {values.accountType === BANK_ACCOUNT_TYPES[0].value ? (
            <Label>
              <LabelText>Bank Routing</LabelText>
              <Field type="text" name="bankRouting" component={FormikInput} size="small" />
              {errors.bankRouting && touched.bankRouting && <FormikError name="bankRouting" />}
            </Label>
          ) : null}
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

BankAccountForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default BankAccountForm;
